import axios from 'axios'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPercentage(
  percentage: number,
  options?: { withSign?: boolean; withPercent?: boolean },
) {
  const { withSign = true, withPercent = true } = options ?? {}

  let result = ''
  if (Number.isNaN(percentage) || percentage === Number.NEGATIVE_INFINITY) {
    result = '0'
  } else if (percentage === Number.POSITIVE_INFINITY) {
    result = '100'
  } else {
    result = percentage < 10 ? percentage.toFixed(1) : formatNumber(percentage)
  }

  result = `${result.replace('.', ',')}${withPercent ? '%' : ''}`

  if (withSign) {
    result = `${percentage > 0 ? '+' : ''}${result}`
  }

  return result
}

export function getAxiosErrorMessage(error: unknown, fallbackMessage?: string) {
  if (
    axios.isAxiosError(error) &&
    error.response?.data &&
    'message' in error.response.data &&
    typeof error.response.data.message === 'string'
  ) {
    return error.response.data.message
  }

  if (
    axios.isAxiosError(error) &&
    error.response?.data &&
    'error' in error.response.data &&
    typeof error.response.data.error === 'string'
  ) {
    return error.response.data.error
  }

  return fallbackMessage ?? 'Une erreur inconnue est survenue, veuillez contacter le support'
}

export function trimSeconds<T extends string | null>(time: T): T {
  if (!time) return time
  return time.slice(0, 5) as T
}

export const numberFormatter = new Intl.NumberFormat('fr-FR')
export const euroFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

export const formatNumber = (value: number) => numberFormatter.format(Math.round(value))

export const formatCentsToEuro = (value: number) => euroFormatter.format(Math.round(value / 100))

export const formatNumberKEuros = (value: number) =>
  `${numberFormatter.format(Math.round(value / 100) / 10)}k €`
